export default "__VITE_ASSET__D95jy8M4__"